import { Box } from '@mui/material';
import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout del portal de clientes externo (`/portal/*`). Surface separado del admin: NO está bajo
 * `_authenticated`, así que no pasa por el guard del admin ni usa su JWT. Cada hoja maneja su
 * propia auth (token de portal en sessionStorage). Acá sólo damos el chrome neutro centrado;
 * el branding del estudio (logo, color) lo aplica cada página con los datos que trae del backend.
 */
export const Route = createFileRoute('/portal')({
  component: PortalLayout,
});

function PortalLayout(): JSX.Element {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'background.default' : '#f4f5f7'),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        px: 2,
        py: { xs: 3, sm: 6 },
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 760 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
